import { CategoriesListScrollContainer } from './CategoriesListScrollContainer';
import { useCategoriesListByPublicationCategorySliced } from '../../../categories/categories.store';
import { CategoriesListItem } from './CategoriesListItem';
import { SkeletonCategoriesList } from './SkeletonCategoriesList';

export const CategoriesList = () => {
  const { data: categoriesListSliced, isLoading } =
    useCategoriesListByPublicationCategorySliced();

  if (isLoading)
    return (
      <CategoriesListScrollContainer>
        <SkeletonCategoriesList />
      </CategoriesListScrollContainer>
    );

  return (
    <CategoriesListScrollContainer>
      {categoriesListSliced?.map((category) => (
        <CategoriesListItem key={category?.id} category={category} />
      ))}
    </CategoriesListScrollContainer>
  );
};
